import axios from 'axios'
import { Notification } from 'element-ui'
import store from '@/store'
import * as types from '@/store/mutation-types'

const instance = axios.create({
  baseURL: '/api'
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // }
})

instance.interceptors.response.use(
  response => {
    response.successful = response.data.status && response.data.status === 'success'
    if (!response.successful) {
      // 过期失效直接退出
      if (response.data.code === 401) {
        store.dispatch('quit')
        return
      }
      // if (res.code === '0001') {
      //   store.commit(types.RECORD_AUTH_USER, '');
      //   window.OriginUrl = `${location.origin}/login`;
      //   router.replace({
      //     path: '/login',
      //     query: {
      //       redirect: router.currentRoute.home
      //     }
      //   });
      // } else {
      //   if (!toastFlags.some(x => response.config.url.includes(x))) {
      //     toast(res.message || res.msg);
      //   }
      // }
      response.data.message && Notification.error({ title: '失败', message: response.data.message })
    } else {
      const black = ['/oa/kaoqingcheck']
      black.every(x => !response.config.url.includes(x)) && response.config.method === 'post' && Notification.success({ title: '成功', message: '操作成功' })
    }
    // 每个接口请求后的权限获取
    response.data && response.data.previllage && store.commit(types.RECORD_GLOBAL_PREVILLAGE, response.data.previllage)
    return response
  },
  error => {
    if (typeof error.response.data === 'object') {
      Notification.error({
        title: '错误',
        message: error.response.data.message
      })
      error.response.status === 401 && store.dispatch('logout')
    } else {
      Notification.warning({
        title: '错误',
        message: '网络连接失败，请稍后重试！'
      })
    }
    return Promise.reject(error)
  }
)

export const createAPI = (url, method, params, config = {}) => {
  if (method === 'get') {
    config.params = params
  } else {
    config.data = params
  }
  return instance({
    url,
    method,
    ...config
  })
}

export default instance
